/**
 * Scroll-Reveal: beobachtet alle [data-scroll-reveal]-Elemente und fügt beim
 * Eintritt in den Viewport die Klasse "is-visible" hinzu. Reines Vanilla JS,
 * respektiert prefers-reduced-motion (siehe assets/custom.css).
 */
(function () {
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var elements = document.querySelectorAll('[data-scroll-reveal]:not(.is-visible)');

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  // Für dynamisch nachgeladene Sections (Theme-Editor, Sections gerendert via AJAX)
  document.addEventListener('shopify:section:load', reveal);
})();
